import React from 'react';

const IconWindows = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 512 512"
    fill="none"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-windows">
    <polygon fill="currentColor" points="0,80 0,240 224,240 224,52" />
    <polygon fill="currentColor" points="256,48 256,240 512,240 512,16" />
    <polygon fill="currentColor" points="256,272 256,464 512,496 512,272" />
    <polygon fill="currentColor" points="0,272 0,432 224,460 224,272" />
  </svg>
);

export default IconWindows;
